import { ratingTypes } from './ratingTypes';

export const moduleTypes = {
  ...ratingTypes,
  SUMMARY_CARD: 'summary-card',
  ESG_SENTIMENT: 'esg-sentiment',
  CLIMATE_STRESS_TEST: 'climate-stress-test',
  INSTRUMENTS: 'instruments',
  RATING_NEWS: 'rating-news',
  RESEARCH: 'research',
  DOCUMENTS: 'documents',
};
